<script>
  import Paragraph from '@components/Templates/Serializer/blocks/Paragraph'
  import Lead from '@components/Templates/Serializer/blocks/Lead'
  import RenderLeavesText from '@components/Templates/Serializer/RenderLeavesText'
  import RenderText from '@components/Templates/Serializer/RenderText'
  import Blockquote from '@components/Templates/Serializer/blocks/Blockquote'
  import ImageBlock from '@components/Templates/Serializer/blocks/ImageBlock'
  import Header from '@components/Templates/Serializer/blocks/Header'
  import List from '@components/Templates/Serializer/blocks/List'
  import Link from '@components/Templates/Serializer/blocks/Link'
  import InfoBlock from '@components/Templates/Serializer/blocks/InfoBlock'
  import SwiperArticle from '@components/Templates/Serializer/blocks/SwiperArticle'
  import Sharing from '@components/Templates/Serializer/blocks/Sharing'
  import PDF from '@components/Templates/Serializer/blocks/PDF'
  import EventCart from '@components/Templates/Serializer/blocks/EventCart'
  export let nodes = []

  const checkFor3DTour = () => { // навешиваем флаг hideOnTerminal на все Хэдеры на вирт туры
    let is3DTour;
    const headerNode = nodes.filter(node => node.type === 'header' && node.nodes.find(n => n.type === 'link'))[0];
    if (headerNode) {
      const linkNode = headerNode.nodes.find(node => node.type === 'link');
      if (linkNode) {
        is3DTour = linkNode.data.href.match('matterport');
      }
    }
    if (is3DTour) {
      headerNode.data.hideOnTerminal = true;
    }
  }

  $: checkFor3DTour(nodes);
</script>

{#each nodes as node}
  {#if node.object === 'block'}
    {#if node.type === 'paragraph'}
      <Paragraph {...node}>
        <svelte:self {...node} />
      </Paragraph>
    {:elseif node.type === 'lead'}
      <Lead {...node}>
        <svelte:self {...node} />
      </Lead>
    {:elseif node.type === 'blockquote' || node.type === 'blockquote_owner'}
      <Blockquote {...node}>
        <svelte:self {...node} />
      </Blockquote>
    {:elseif node.type === 'header' || node.type === 'heading_two'}
      <Header {...node}>
        <svelte:self {...node} />
      </Header>
    {:elseif node.type === 'image'}
      <ImageBlock {...node}>
        <svelte:self {...node} />
      </ImageBlock>
    {:elseif node.type === 'ol_list' || node.type === 'ul_list' || node.type === 'list_item'}
      <List {...node}>
        <svelte:self {...node} />
      </List>
    {:elseif node.type === 'sharing'}
      <Sharing {...node} />
    {:elseif node.type === 'pdfBlock'}
      <PDF {...node} />
    {:elseif node.type === 'info_block' || node.type === 'info_block_item' || node.type === 'info_block_title' || node.type === 'info_block_content'}
      <InfoBlock {...node}>
        <svelte:self {...node} />
      </InfoBlock>
    {:elseif node.type === 'gallery'}
      <SwiperArticle {...node} />
    {:elseif node.type === 'event_card'}
      <EventCart {...node}>
        <svelte:self {...node} />
      </EventCart>
    {:else}
      <div>
        <svelte:self {...node} />
      </div>
    {/if}
  {:elseif node.type === 'link'}
    <Link {...node} >
      <svelte:self {...node} />
    </Link>
  {:elseif node.object === 'text'}
    <RenderText {...node} />
  {/if}
{:else}
  <div>
    Текст отсутствует
  </div>
{/each}



